export const AirportDelayMap = {
  top: {
    id: 'div-gpt-ad-1500406358802-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_AirportDelay_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500406274331-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_AirportDelay_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1500406447041-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_AirportDelay_top_300x250',
  },
};



// WEBPACK FOOTER //
// ./modules/AirportDelayMap/components/ads.js